import BlogGrid1 from "@components/elements/blog/BlogGrid1";
import SectionTitle from "@components/elements/SectionTitle";
import Link from "next/link";
const BlogSection1 = ({ pages, blog }) => {
  const currentPage = pages.find(item => item.id === 66);

  return (
    <>
      <div className="section-padding pb-0">
        <div className="container">
        <SectionTitle
            style={2}
            title="Ressources et conseils"
            subTitle="Libérez votre curiosité grâce à des articles captivants, des avis d'experts et des conseils inspirants."
          />

          <div className="grid grid-cols-1 lg:grid-cols-2  xl:grid-cols-3 gap-7 mt-20 ">
            {blog.map((item, i) => (
              <BlogGrid1 item={item} key={i} currentPage={currentPage} />
            ))}
          </div>
          <div className="transition duration-300 ease-in-out transform hover:-translate-y-1 flex items-center justify-center">
            <Link
              href={`/${currentPage?.seo_permalink}`}
              className="px-4 py-2 mt-2 text-pgray-600 transition-colors duration-200 transform border border-pgray-100 rounded-lg dark:text-pgray-200 dark:border-pgray-200 hover:bg-primary-50/50 dark:hover:bg-pgray-700 focus:outline-none">Voir plus d&apos;articles</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogSection1;
